import React, { forwardRef, memo, useMemo } from "react";
import { useRef } from "react";
import { useEffect, useState } from "react";
import ReactSelect, { components } from "react-select";
import ToolBar from "../editor/ToolBar";
import AsyncSelect from "react-select/async";
import { useDispatch, useSelector } from "react-redux";
import * as commonData from "../../Common";
import { useParams } from "react-router-dom";
import action from "../../Actions";
import { param } from "jquery";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import CustomOption from "../CustomOption";
import PopOver from "../PopOver";

const EditField = forwardRef((props, refs) => {
  const params = useParams();
  const dateRef = useRef(null);
  const store = useSelector((state) => state.boardAttribute);
  const dispatch = useDispatch();
  const [editField, setEditField] = useState(props);
  const [boardData, setBoardData] = useState({});
  let [testFilter, setTestFilter] = useState([]);
  let [isValidationcheck, setIsValidationCheck] = useState({});
  let [effortInput, setEffort] = useState({});
  let [effortData, setEffortData] = useState({});
  let [effortSubmitData, setEffortSubmitData] = useState({});

  const inputEffort = useRef(null);
  const allEffortRef = useRef({});
  let [state, setState] = useState({
    formdata: { ...props.rows },
    users: [],
    allEfforts: {},
  });
  const isClearing = useRef(false);

  const dateref = useRef(null);
  useEffect(() => {
    setEditField(props);
    editField?.refs?.current?.focus();
    setBoardData(props.boardData);
    setState((prevState) => ({
      ...prevState,
      formdata: { ...props.rows },
    }));
  }, [props]);
  useEffect(() => {
    setEffort({ [editField.field]: props?.rows?.[editField.field] });
    setIsValidationCheck(props);
  }, []);

  // useEffect(() => {
  //   setMonitor(props.newMonitor || store.monitor);
  // }, [props.newMonitor, store.monitor]);

  const getToolBarData = (field, data) => {
    props.ongetRawDataHandle(field, data);
  };
  useEffect(() => {
    const filOptions = [...testFilter];
    filOptions.push(editField?.allOptions);
    setTestFilter(filOptions);
  }, [editField?.allOptions]);
  useEffect(() => {
    if (dateRef.current) {
      dateRef.current.input.focus();
    }
  }, [dateRef]);
  // useEffect(() => {
  //   if (props.users) {
  //     setState((state) => {
  //       return {
  //         ...state,
  //         users: Object.entries(props.users).map(([key, val]) => ({
  //           ...val,
  //         })),
  //       };
  //     });
  //   }
  // }, [props.users]);

  const removeMonitorHandler = async (data) => {
    const api = commonData.commonData().apiUrl;
    const details = {
      app_token: boardData.app_token,
      user_uuid: boardData.user_uuid,
      attribute_set_key: boardData.attribute_set_key,
      customer_tattle_uuid: +params.id,
      attribute_type: "monitoring",
      attribute_key: "monitoring",
      attribute_value: [data],
    };
    props.removeMonitorFromAddMonitor(data);
    dispatch(action.removeMonitor(details, "status"));
  };
  const handleMouseDown = (event) => {
    // Check if the clear indicator was clicked
    if (event.target.classList.contains("react-datepicker__close-icon")) {
      isClearing.current = true; // Set clearing flag
    }
  };
  const dateChangeHandler = (evt, field) => {
    editField.onChange(evt, field);
    if (editField.rows[field] && editField.rows[field] !== "") {
      setState((state) => {
        return {
          ...state,
          formdata: {
            ...state.formdata,
            [field]: new Date(evt),
          },
        };
      });
    }
    setState((state) => {
      return {
        ...state,
        formdata: {
          ...state.formdata,
          [field]: evt ? new Date(evt) : null,
        },
      };
    });
    // setPickerDate(evt);
    setTimeout(() => {
      if (dateRef.current) {
        dateRef.current.input.focus();
      }
    });
  };
  useEffect(() => {
    if (editField.attribute_type == "effort") {
      (async () => {
        const response = await fetch(
          `${process.env.REACT_APP_API}/get-efforts`,
        );
        const rdata = await response.json();
        setEffortData(rdata);
      })();
    }
  }, []);

  const getCalenderBlur = (evt, nevt) => {
    setTimeout(() => {
      const {
        name,
        value,
        _wrapperState: { initialValue },
      } = evt.target;

      if (!editField.rows[name]) {
        editField.onBlur(evt);
      } else if (
        (value === initialValue && !editField.show_reason) ||
        editField.rows[name] === ""
      ) {
        editField.onBlur(evt);
        return;
      } else if (editField.rows[name] && !editField.show_reason) {
        editField.onBlur(evt);
      } else if (value === "" && editField?.errors?.isValid === true) {
        editField.onBlur(evt);
      } else {
        if (editField?.errors?.isValid && isClearing.current === false) {
          editField.removeAllEditInline(evt.details_pane);
        }

        return;
      }
    }, 0);
  };
  const fetchData = async (url, evt, field = null) => {
    const response = await fetch(url);
    const data = await response.json();
    if (!Array.isArray(data)) {
      if (evt) {
        return Object.keys(data)
          .map((it) => {
            return {
              label: data[it].id + " " + data[it].title,
              value: data[it].id,
            };
          })
          .filter((fi) => fi.label.toLowerCase().includes(evt.toLowerCase()));
      } else {
        return Object.keys(data).map((it) => {
          return {
            label: data[it].id + " " + data[it].title,
            value: data[it].id,
          };
        });
      }
    } else {
      if (evt) {
        return data
          .filter((it) => it.value.toLowerCase().includes(evt.toLowerCase()))
          .map((i) => ({ label: i.value, value: i.id }));
      } else {
        if (field === "release") {
          return data
            .filter((ite) => ite?.current === true)
            ?.map((i) => ({ label: i.value, value: i.id }));
        }
        return data.map((i) => ({ label: i.value, value: i.id }));
      }
    }
  };
  const customStyles = {
    menu: (sty) => {
      return {
        ...sty,
        zIndex: 9,
      };
    },
    multiValue: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center", // Align items center
      height: 20,
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#333", // Customize label color if needed
    }),
  };
  function validateInput(input, key, name) {
    let valid = false;
    // check a number or character
    const regex = /^\d*$/;

    //check the hour key and its value should not greater than 7
    if (key === "effort_in_hours" && input > 8) {
      return;
    }
    if (key === "effort_in_days" && input > 10000) {
      return;
    }
    if (regex.test(input) || input === "") {
      setEffort((state) => {
        return {
          [editField.field]: {
            effort_in_days: effortInput["effort_in_days"] || 0,
            effort_in_hours: effortInput["effort_in_hours"] || 0,
            ...state[editField.field],
            [key]: +input,
          },
        };
      });
    }
  }

  const effortChangeHandler = (evt) => {
    const { name, value } = evt.target;

    const { rows } = editField;
    const effort = rows[editField.field];
    let checkValuenotnull = false;

    validateInput(value, name);
    return;
  };

  function isNotNullUndefinedOrNaN(value) {
    // return value !== null && value !== undefined;
    return value !== undefined;
  }

  function checkObjectFields(obj) {
    if (typeof obj === "object") {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (!isNotNullUndefinedOrNaN(obj[key])) {
            return false; // If any field fails the check, return false
          }
        }
      }
      return true; // All fields passed the check
    }
    return false;
  }

  function deepCompare(obj1, obj2) {
    const effort = obj1[editField.field];
    if (
      effort &&
      obj2 &&
      typeof effort === "object" &&
      typeof obj2 === "object"
    ) {
      return +effort?.total_hours === +obj2?.total_hours;
    } else if (
      effort &&
      typeof effort === "object" &&
      effort?.total_hours !== 0
    ) {
      return false;
    } else if (effort.effort === "") {
      return true;
    }
    return false;
  }

  useEffect(() => {
    try {
      let listener = async (e) => {
        if (!inputEffort.current || inputEffort?.current?.contains(e.target)) {
          if (Object.keys(allEffortRef.current).length == 0) {
          }

          return;
        }

        let newvalue = {};
        for (let key in effortSubmitData) {
          if (key === "effort") {
            if (effortSubmitData["total_hours"] === 0) {
              newvalue = {
                [key]: "",
                ...newvalue,
              };
            } else {
              newvalue = {
                [key]: effortSubmitData[key] || "",
                ...newvalue,
              };
            }
          } else {
            if (!effortSubmitData[key]) {
              newvalue = {
                [key]: 0,
                ...newvalue,
              };
            } else {
              newvalue = {
                [key]: +effortSubmitData[key],
                ...newvalue,
              };
            }
          }
        }

        if (effortSubmitData.hasOwnProperty("effort")) {
          newvalue = {
            [editField.field]: { ...newvalue },
          };
        } else {
          newvalue = {};
        }

        if (!deepCompare(newvalue, editField.rows?.[editField.field])) {
          editField.onChange(newvalue);
        }

        editField.onBlur();
      };

      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);

      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    } catch (error) {
      console.log(error);
    }
  }, [inputEffort, isValidationcheck, effortSubmitData]);

  useEffect(() => {
    let effort = {};
    if (typeof effortInput === "object") {
      // check the default effor value is object or not else we will make it as object
      if (
        effortInput[editField.field]?.effort_in_days &&
        effortInput[editField.field]?.effort_in_hours
      ) {
        effort = {
          ...effortInput[editField.field],
          total_hours:
            effortInput[editField.field]?.effort_in_days * 8 +
            +effortInput[editField.field]?.effort_in_hours,
        };
      } else if (effortInput[editField.field]?.effort_in_days) {
        effort = {
          ...effortInput[editField.field],
          total_hours: effortInput[editField.field]?.effort_in_days * 8,
        };
      } else if (effortInput[editField.field]?.effort_in_hours) {
        effort = {
          ...effortInput[editField.field],
          total_hours: effortInput[editField.field]?.effort_in_hours,
        };
      } else {
        effort = {
          effort: "",
          ...effortInput[editField.field],
          total_hours: 0,
        };
      }

      // get the effort key by total hours
      if (effort?.hasOwnProperty("total_hours") && effort.total_hours) {
        effort = {
          ...effort,
          effort: getKeyFromEffort(effort.total_hours),
        };
      }

      setEffortSubmitData(effort);
    } else {
      setEffort({});
    }
  }, [effortInput, effortData]);

  const getKeyFromEffort = (val) => {
    let resultKey;
    let newObj = Object.keys(effortData);

    for (let i = newObj.length - 1; i >= 0; i--) {
      const key = newObj[i];
      const value = effortData[key];
      if (val >= value?.total_hours) {
        resultKey = key;
      }
    }
    return resultKey;
  };
  const getTransformUsers = useMemo(() => {
    const users = Object.entries(props.users || {}).map(([key, val]) => ({
      ...val,
    }));
    return users;
  }, [props.users]);
  const getError = () => {};
  const checkIdIsExistOrNot = (item) => {
    return getTransformUsers.some((obj) => obj.user_uuid === item);
  };
  const getTheItemOption = (item) => {
    const data = getTransformUsers.find((ob) => ob.user_uuid == item);
    return data;
  };
  const getAddMonitordata = () => {
    const newpro = [];
    try {
      if (editField.attribute_type === "monitoring") {
        const newprofile = props?.newMonitor.forEach((item) => {
          if (item && checkIdIsExistOrNot(item)) {
            newpro.push(getTheItemOption(item));
          }
        });

        return newpro;
      }
    } catch (err) {
      console.log(err.message);
    }
  };
  function valueExistsInArray(array, value) {
    for (const item of array) {
      if (item == value) {
        return true;
      }
    }
    return false;
  }
  const getPeoplesCall = async (evt, apiUrl) => {
    if (evt && state.users.length > 0) {
      return state.users.filter((item) =>
        item.label.toLowerCase().includes(evt.toLowerCase()),
      );
    }
    const resp = await fetch(apiUrl);
    const rdata = await resp.json();

    const newdata = Object.entries(rdata).map(([key, val]) => {
      return {
        label: val.name,
        value: val.user_uuid,
        profile_image: val.profile_image,
      };
    });
    setState((state) => {
      return {
        ...state,
        users: newdata,
      };
    });
    return newdata;
  };

  if (
    editField.attribute_type === "text" ||
    editField.attribute_type === "name"
  ) {
    return (
      <>
        {" "}
        <input
          type="text"
          value={
            editField["newerror"]?.isValid ||
            editField["newerror"]?.isValid === undefined
              ? editField.rows?.[editField.field]
              : null
          }
          name={editField.field}
          placeholder={editField.placeholder}
          disabled={editField.disabled}
          onChange={editField.onChange}
          ref={editField.refs}
          className="form-control"
          onBlur={editField.onBlur}
          autoComplete="off"
        />
        <span className="error-feedback">
          {editField["errors"]?.message || editField["newerror"]?.message}
        </span>
      </>
    );
  }
  if (editField.attribute_type === "number") {
    return (
      <>
        {" "}
        <input
          type="text"
          value={
            editField?.isValid || editField?.isValid === undefined
              ? editField.rows?.[editField.field]
              : null
          }
          name={editField.field}
          placeholder={editField.placeholder}
          disabled={editField.disabled}
          onChange={editField.onChange}
          min={0}
          ref={editField.refs}
          className="form-control"
          onBlur={
            editField.isValid || editField.isValid === undefined
              ? editField.onBlur
              : null
          }
          autoComplete="off"
        />
        <span className="error-feedback">
          {editField["errors"]?.message || editField["newerror"]?.message}
        </span>
      </>
    );
  } else if (editField.attribute_type === "tel") {
    return (
      <>
        <input
          type="tel"
          value={
            editField["newerror"]?.isValid ||
            editField["newerror"]?.isValid === undefined
              ? editField.rows[editField.field]
              : null
          }
          name={editField.field}
          onChange={editField.onChange}
          ref={editField.refs}
          className="form-control"
          onBlur={editField.onBlur}
          autoComplete="off"
        />
        <span className="error-feedback">
          {editField["errors"]?.message || editField["newerror"]?.message}
        </span>
      </>
    );
  } else if (editField.attribute_type === "textarea") {
    return (
      <textarea
        onBlur={editField.onBlur}
        ref={editField.refs}
        className="form-control"
        value={editField.rows[editField.field] || ""}
        onChange={editField.onChange}
        name={editField.field}
        rows="3"
      />
    );
  } else if (editField.attribute_type === "select") {
    const newoptions = [];
    if (editField.options.length > 0) {
      editField.options.forEach((item, index) => {
        newoptions.push({ label: item.option_name, value: item._id, ...item });
      });
    }
    let datafinal = "";
    if (editField.is_multiple && editField.rows[editField.field]) {
      if (Array.isArray(editField.rows[editField.field])) {
        datafinal = editField.rows[editField.field];
      } else {
        datafinal = editField.rows[editField.field];
      }
    } else {
      datafinal = editField.rows[editField.field];
    }
    return (
      <ReactSelect
        name={editField.field}
        options={newoptions}
        styles={customStyles}
        maxMenuHeight={175}
        isClearable
        isDisabled={editField.disabled}
        placeholder={editField.placeholder || "Select..."}
        menuPlacement="auto"
        value={newoptions.filter((fil) =>
          !Array.isArray(datafinal)
            ? editField.rows?.[editField.field] === fil.value
            : datafinal?.includes?.(fil.value),
        )}
        defaultValue={newoptions.filter((fil) =>
          !Array.isArray(datafinal)
            ? editField.rows?.[editField.field] === fil.value
            : datafinal?.includes?.(fil.value),
        )}
        ref={editField?.refs}
        onBlur={editField.onBlur}
        onChange={(evt) =>
          editField.onChange(evt, editField.field, editField.is_multiple)
        }
        isMulti={editField.is_multiple}
      />
    );
  } else if (editField.attribute_type === "priority") {
    const newoptions = [];
    if (editField?.options?.length > 0) {
      editField.options.forEach((item, index) => {
        newoptions.push({ label: item.option_name, value: item._id });
      });
    }
    let datafinal = "";
    if (editField.is_multiple && editField.rows[editField.field]) {
      if (Array.isArray(editField.rows[editField.field])) {
        datafinal = editField.rows[editField.field];
      } else {
        datafinal = editField.rows[editField.field];
      }
    } else {
      datafinal = editField.rows[editField.field];
    }
    return (
      <ReactSelect
        name={editField.field}
        options={newoptions}
        isClearable
        styles={customStyles}
        maxMenuHeight={175}
        defaultValue={newoptions.filter((fil) =>
          !Array.isArray(datafinal)
            ? editField.rows[editField.field] === fil.value
            : datafinal.includes(fil.value),
        )}
        ref={editField?.refs}
        onBlur={editField.onBlur}
        menuPlacement="auto"
        onChange={(evt) =>
          editField.onChange(evt, editField.field, editField.is_multiple)
        }
        isMulti={editField.is_multiple}
      />
    );
  } else if (editField.attribute_type === "status") {
    const newoptions = [];
    if (editField?.options?.length > 0) {
      editField.options.forEach((item, index) => {
        newoptions.push({ label: item.name, value: item._id });
      });
    }

    return (
      <ReactSelect
        name={editField.field}
        options={newoptions}
        maxMenuHeight={175}
        styles={customStyles}
        value={newoptions.filter(
          (fil) => fil.value == editField.rows[editField.field],
        )}
        menuPlacement="auto"
        ref={editField.refs}
        onBlur={editField.onBlur}
        onChange={(evt) => editField.onChange(evt, editField.field)}
      />
    );
  } else if (editField.attribute_type === "category") {
    const newoptions = [];
    if (editField?.options?.length > 0) {
      editField.options.forEach((item, index) => {
        newoptions.push({ label: item.name, value: item._id });
      });
    }

    return (
      <ReactSelect
        name={editField.field}
        maxMenuHeight={175}
        styles={customStyles}
        options={newoptions}
        isDisabled={editField.disabled}
        placeholder={editField.placeholder || "Select..."}
        value={newoptions.filter(
          (fil) => fil.value === editField.rows[editField.field],
        )}
        menuPlacement="auto"
        ref={editField.refs}
        className="abc"
        onBlur={editField.onBlur}
        onChange={(evt) => editField.onChange(evt, editField.field)}
      />
    );
  } else if (editField.attribute_type === "email") {
    return (
      <>
        <input
          type="email"
          value={
            editField["newerror"]?.isValid ||
            editField["newerror"]?.isValid === undefined
              ? editField.rows[editField.field]
              : null
          }
          name={editField.field}
          onChange={editField.onChange}
          ref={editField.refs}
          className="form-control"
          onBlur={editField.onBlur}
        />
        <span className="error-feedback">
          {editField["errors"]?.message || editField["newerror"]?.message}
        </span>
      </>
    );
  } else if (editField.attribute_type === "url") {
    return (
      <>
        <input
          type="url"
          value={
            editField["newerror"]?.isValid ||
            editField["newerror"]?.isValid === undefined
              ? editField.rows[editField.field]
              : null
          }
          name={editField.field}
          placeholder={editField.placeholder || "Paste sheet or doc link"}
          disabled={editField.disabled}
          onChange={editField.onChange}
          ref={editField.refs}
          className="form-control"
          onBlur={editField.onBlur}
        />
        <span className="error-feedback">
          {editField["errors"]?.message || editField["newerror"]?.message}
        </span>
      </>
    );
  } else if (editField.attribute_type === "start_date") {
    const { rows } = editField;
    let currentDate = new Date();
    let pastDate = new Date(currentDate); // Create a new instance to avoid modifying the original date
    pastDate.setDate(currentDate.getDate() - 30);
    let crossDate;
    if (editField.field === "start_date") {
      crossDate = new Date().setDate(new Date().getDate() + 30);
    }

    if (editField.field === "start_date" && rows.end_date) {
      let val =
        editField.field === "start_date" ? rows.end_date : rows.start_date;
      currentDate = new Date(val);
      pastDate = new Date(currentDate).setDate(
        new Date(currentDate).getDate() - 30,
      );
      crossDate = currentDate.setDate(new Date(rows.end_date).getDate());
    }
    if (
      editField.field === "start_date" &&
      rows.go_live_date &&
      !rows.end_date
    ) {
      let val =
        editField.field === "start_date" ? rows.go_live_date : rows.start_date;
      currentDate = new Date(val);
      pastDate = new Date(currentDate).setDate(
        new Date(currentDate).getDate() - 30,
      );
      crossDate = currentDate.setDate(new Date(currentDate).getDate());
    }

    //qa start date less than qa end date and go live date if available
    if (
      editField.field === "qa_start_date" &&
      rows.qa_end_date &&
      rows.go_live_date
    ) {
      pastDate = new Date(rows.qa_end_date || rows.go_live_date).setDate(
        new Date(rows?.qa_end_date || rows.go_live_date).getDate() - 30,
      );
      crossDate = new Date(rows.qa_end_date || rows.go_live_date).setDate(
        new Date(rows?.qa_end_date || rows.go_live_date).getDate(),
      );
    } else if (editField.field === "qa_start_date" && rows.qa_end_date) {
      pastDate = new Date(rows.qa_end_date || rows.go_live_date).setDate(
        new Date(rows?.qa_end_date || rows.go_live_date).getDate() - 30,
      );
      crossDate = new Date(rows?.qa_end_date).setDate(
        new Date(rows?.qa_end_date).getDate(),
      );
    } else if (editField.field === "qa_start_date" && rows.go_live_date) {
      pastDate = new Date(rows.go_live_date || rows.qa_end_date).setDate(
        new Date(rows?.go_live_date || rows.go_live_date).getDate() - 30,
      );
      crossDate = new Date(rows?.go_live_date).setDate(
        new Date(rows?.go_live_date).getDate(),
      );
    } else if (editField.field === "qa_start_date") {
      pastDate = new Date().setDate(new Date().getDate() - 30);
      crossDate = new Date().setDate(new Date().getDate() + 30);
    }

    return (
      <div onMouseDown={handleMouseDown}>
        {" "}
        <ReactDatePicker
          selected={
            state.formdata[editField.field] &&
            !isNaN(Date.parse(state.formdata[editField.field]))
              ? new Date(state.formdata[editField.field])
              : null
          }
          name={editField.field}
          dateFormat="dd-MM-yyyy"
          onChange={(evt) => dateChangeHandler(evt, editField.field)}
          onBlur={!editField.show_reason ? editField.onBlur : getCalenderBlur}
          // minDate={pastDate}
          // maxDate={crossDate}
          ref={dateRef}
          isClearable
          className="rasta-stripes"
          autoComplete="off"
          placeholderText="dd-mm-yyyy"
        />{" "}
        <span className="error-feedback">
          {editField["errors"]?.message || editField["newerror"]?.message}
        </span>
      </div>
    );
  } else if (editField.attribute_type === "end_date") {
    const { rows } = editField;
    let currentDate = new Date();
    let pastDate = currentDate.setDate(currentDate.getDate() - 30);
    let crossdate;
    if (editField.field === "end_date") {
      crossdate = new Date().setDate(new Date().getDate() + 30);
    }

    if (editField.field === "end_date" && rows.start_date) {
      pastDate = new Date(rows.start_date).setDate(
        new Date(rows.start_date).getDate(),
      );
      crossdate = new Date(rows.start_date).setDate(
        new Date(rows.start_date).getDate() + 30,
      );
    }
    if (editField.field === "end_date" && rows.go_live_date) {
      let val = editField.field === "end_date" && rows.go_live_date;
      currentDate = new Date(val);

      pastDate = new Date(currentDate).setDate(
        new Date(currentDate).getDate() - 30,
      );
      crossdate = currentDate.setDate(currentDate.getDate());
    }
    if (
      editField.field === "end_date" &&
      rows.start_date &&
      rows.go_live_date
    ) {
      let val = editField.field === "end_date" && rows.go_live_date;
      currentDate = new Date(val);

      pastDate = new Date(new Date(rows.start_date)).setDate(
        new Date(new Date(rows.start_date)).getDate(),
      );
      crossdate = new Date(currentDate).setDate(
        new Date(currentDate).getDate(),
      );
    }

    //qa end should be grater than qa start date and less than go live date
    if (
      editField.field === "qa_end_date" &&
      rows.qa_start_date &&
      rows.go_live_date
    ) {
      pastDate = new Date(rows?.qa_start_date).setDate(
        new Date(rows.qa_start_date).getDate(),
      );

      crossdate = new Date(rows?.go_live_date).setDate(
        new Date(rows?.go_live_date).getDate(),
      );
    } else if (editField.field === "qa_end_date" && rows.qa_start_date) {
      pastDate = new Date(rows?.qa_start_date).setDate(
        new Date(rows.qa_start_date).getDate(),
      );

      crossdate = new Date(rows?.qa_start_date).setDate(
        new Date(rows?.qa_start_date).getDate() + 30,
      );
    } else if (
      editField.field === "qa_end_date" &&
      rows.go_live_date &&
      !rows.qa_start_date
    ) {
      pastDate = new Date(rows?.go_live_date).setDate(
        new Date(rows.go_live_date).getDate() - 30,
      );

      crossdate = new Date(rows?.go_live_date).setDate(
        new Date(rows?.go_live_date).getDate(),
      );
    } else if (
      editField.field === "qa_end_date" &&
      !rows.qa_start_date &&
      !rows.go_live_date
    ) {
      pastDate = new Date().setDate(new Date().getDate() - 30);
      crossdate = new Date().setDate(new Date().getDate() + 30);
    }
    return (
      <div onMouseDown={handleMouseDown}>
        {" "}
        <ReactDatePicker
          selected={
            state.formdata[editField.field] &&
            !isNaN(Date.parse(state.formdata[editField.field]))
              ? new Date(state.formdata[editField.field])
              : null
          }
          name={editField.field}
          dateFormat="dd-MM-yyyy"
          onChange={(evt) => dateChangeHandler(evt, editField.field)}
          onBlur={!editField.show_reason ? editField.onBlur : getCalenderBlur}
          // minDate={pastDate}
          // maxDate={crossdate}
          ref={dateRef}
          isClearable
          className="rasta-stripes"
          autoComplete="off"
          placeholderText="dd-mm-yyyy"
        />{" "}
        <span className="error-feedback">
          {editField["errors"]?.message || editField["newerror"]?.message}
        </span>
      </div>
    );
  } else if (editField.attribute_type === "go_live_date") {
    const { rows } = editField;
    let pastDate = new Date();
    let crossDate = new Date();
    pastDate = new Date().setDate(new Date().getDate() - 30);
    crossDate = new Date().setDate(new Date().getDate() + 30);
    if (rows.start_date) {
      pastDate = new Date(new Date(rows.start_date)).setDate(
        new Date(new Date(rows.start_date)).getDate(),
      );
    }
    if (rows.end_date) {
      pastDate = new Date(new Date(rows.end_date)).setDate(
        new Date(new Date(rows.end_date)).getDate(),
      );
    }
    if (rows.start_date && rows.end_date) {
      pastDate = new Date(
        Math.max(new Date(rows.start_date), new Date(rows.end_date)),
      ).setDate(
        new Date(
          Math.max(new Date(rows.start_date), new Date(rows.end_date)),
        ).getDate(),
      );
    }
    if (rows.qa_start_date) {
      pastDate = new Date(new Date(rows.qa_start_date)).setDate(
        new Date(rows.qa_start_date).getDate(),
      );
    }
    if (rows.qa_end_date) {
      pastDate = new Date(new Date(rows.qa_start_date)).setDate(
        new Date(rows.qa_start_date).getDate(),
      );
    }
    if (rows.qa_start_date && rows.qa_end_date) {
      pastDate = new Date(
        Math.max(new Date(rows.qa_start_date), new Date(rows.qa_end_date)),
      ).setDate(
        new Date(
          Math.max(new Date(rows.qa_start_date), new Date(rows.qa_end_date)),
        ).getDate(),
      );
    }
    if (rows.qa_start_date && rows.qa_end_date && rows.start_date) {
      pastDate = new Date(
        Math.max(
          new Date(rows.qa_start_date),
          new Date(rows.qa_end_date),
          new Date(rows.start_date),
        ),
      ).setDate(
        new Date(
          Math.max(
            new Date(rows.qa_start_date),
            new Date(rows.qa_end_date),
            new Date(rows.start_date),
          ),
        ).getDate(),
      );
    }
    if (
      rows.qa_start_date &&
      rows.qa_end_date &&
      rows.start_date &&
      rows.end_date
    ) {
      pastDate = new Date(
        Math.max(
          new Date(rows.qa_start_date),
          new Date(rows.qa_end_date),
          new Date(rows.start_date),
          new Date(rows.end_date),
        ),
      ).setDate(
        new Date(
          Math.max(
            new Date(rows.qa_start_date),
            new Date(rows.qa_end_date),
            new Date(rows.start_date),
            new Date(rows.end_date),
          ),
        ).getDate(),
      );
    }

    return (
      <div onMouseDown={handleMouseDown}>
        {" "}
        <ReactDatePicker
          selected={
            state.formdata[editField.field] &&
            !isNaN(Date.parse(state.formdata[editField.field]))
              ? new Date(state.formdata[editField.field])
              : null
          }
          name={editField.field}
          dateFormat="dd-MM-yyyy"
          onChange={(evt) => dateChangeHandler(evt, editField.field)}
          onBlur={!editField.show_reason ? editField.onBlur : getCalenderBlur}
          isClearable
          // minDate={pastDate}
          // maxDate={crossDate}
          ref={dateRef}
          className="rasta-stripes"
          autoComplete="off"
          placeholderText="dd-mm-yyyy"
        />{" "}
        <span className="error-feedback">
          {editField["errors"]?.message || editField["newerror"]?.message}
        </span>
      </div>
    );
  } else if (editField.attribute_type === "radio") {
    return (
      <input
        type="radio"
        defaultValue={editField.rows[editField.field]}
        name={editField.field}
        onChange={editField.onChange}
        ref={editField.refs}
        className="form-input-radio"
        onBlur={editField.onBlur}
      />
    );
  } else if (editField.attribute_type === "toggle") {
    const isChecked =
      editField.rows?.[editField.field] === true ||
      editField.rows?.[editField.field] === 1 ||
      editField.rows?.[editField.field] === "1" ||
      editField.rows?.[editField.field] === "true";
    return (
      <div className="form-check form-switch me-1">
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          name={editField.field}
          disabled={editField.disabled}
          onChange={editField.toggleHandler || editField.onChange}
          id={`flexSwitchCheckChecked_${editField.field}`}
          value={isChecked}
          checked={isChecked}
        />
        <label
          className="form-check-label"
          htmlFor={`flexSwitchCheckChecked_${editField.field}`}
        ></label>
      </div>
    );
  } else if (editField.attribute_type === "multi-select") {
    const { options, rows } = editField;

    let values = [];

    if (rows.hasOwnProperty(editField.field)) {
      values = rows[editField.field];
    }

    return (
      <div class="me-1 multi-select">
        {options &&
          options.map((ite) => (
            <button
              className={`multi-select-button ${
                values.includes(ite._id) ? "multi-selected" : ""
              }`}
              onClick={() => {
                let rowdata = [...(rows?.[editField.field] ?? [])];
                if (rowdata.includes(ite._id)) {
                  rowdata = rowdata.filter((lt) => lt !== ite._id);
                } else {
                  rowdata.push(ite._id);
                }
                return props.toggleHandlerMultiple(rowdata, editField.field);
              }}
              type="button"
            >
              {ite.option_name}
            </button>
          ))}
      </div>
    );
  } else if (editField.attribute_type === "checkbox") {
    return (
      <input
        type="checkbox"
        defaultValue={editField.rows[editField.field]}
        name={editField.field}
        onChange={editField.onChange}
        ref={editField.refs}
        className="form-check-input   "
        onBlur={editField.onBlur}
      />
    );
  } else if (editField.attribute_type === "attachment") {
    return (
      <input
        type="file"
        defaultValue={editField.rows[editField.field]}
        name={editField.field}
        onChange={editField.onChange}
        ref={editField.refs}
        className="form-check-input   "
        onBlur={editField.onBlur}
      />
    );
  } else if (editField.attribute_type === "radio") {
    return (
      <input
        type="radio"
        defaultValue={editField.rows[editField.field]}
        name={editField.field}
        onChange={editField.onChange}
        ref={editField.refs}
        className="form-check-input   "
        onBlur={editField.onBlur}
      />
    );
  } else if (
    editField.attribute_type === "api" ||
    editField.attribute_type === "release"
  ) {
    try {
      const options = [];
      (editField.options || []).forEach((item) => {
        options.push({
          label: item.value || item.label,
          value: item.id || item.value,
        });
      });

      if (
        editField.is_multiple &&
        Array.isArray(editField.rows[editField.field])
      ) {
        return (
          <>
            <AsyncSelect
              cacheOptions
              defaultOptions
              styles={customStyles}
              maxMenuHeight={175}
              isDisabled={editField.disabled}
              placeholder={editField.placeholder || "Select..."}
              defaultValue={options.filter((fil) =>
                valueExistsInArray(editField.rows[editField.field], fil.value),
              )}
              loadOptions={(evt) =>
                editField?.getApiCall
                  ? editField.getApiCall(editField.api_url, evt)
                  : fetchData(editField.api_url, evt)
              }
              ref={editField.refs}
              onBlur={editField.onBlur}
              isClearable
              isMulti={editField.is_multiple}
              onChange={(evt) => {
                editField.onChange(evt, editField.field, editField.is_multiple);
              }}
            />
          </>
        );
      } else {
        return (
          <>
            <AsyncSelect
              cacheOptions
              defaultOptions
              maxMenuHeight={175}
              isClearable
              styles={customStyles}
              isDisabled={editField.disabled}
              placeholder={editField.placeholder || "Select..."}
              defaultValue={options.filter(
                (fil) => fil.value == editField.rows[editField.field],
              )}
              loadOptions={(evt) =>
                editField?.getApiCall
                  ? editField.getApiCall(editField.api_url, evt)
                  : fetchData(editField.api_url, evt, editField.field)
              }
              ref={editField.refs}
              onBlur={editField.onBlur}
              isMulti={editField.is_multiple}
              onChange={(evt) => {
                editField.onChange(evt, editField.field, editField.is_multiple);
              }}
            />
          </>
        );
      }
    } catch (error) {
      console.log(error);
    }
  } else if (editField.attribute_type === "product") {
    try {
      const options = [];
      editField.options.forEach((item) => {
        options.push({ label: item.value, value: item.id });
      });

      if (
        editField.is_multiple &&
        Array.isArray(editField.rows[editField.field])
      ) {
        return (
          <>
            <AsyncSelect
              cacheOptions
              defaultOptions
              styles={customStyles}
              maxMenuHeight={175}
              value={options.filter((fil) =>
                valueExistsInArray(editField.rows[editField.field], fil.value),
              )}
              loadOptions={(evt) => fetchData(editField.api_url, evt)}
              ref={editField.refs}
              onBlur={editField.onBlur}
              isMulti={editField.is_multiple}
              onChange={(evt) => {
                editField.onChange(evt, editField.field, editField.is_multiple);
              }}
            />
          </>
        );
      } else {
        return (
          <>
            <AsyncSelect
              cacheOptions
              defaultOptions
              maxMenuHeight={175}
              styles={customStyles}
              value={options.filter(
                (fil) => fil.value == editField.rows[editField.field],
              )}
              loadOptions={(evt) => fetchData(editField.api_url, evt)}
              ref={editField.refs}
              onBlur={editField.onBlur}
              isMulti={editField.is_multiple}
              onChange={(evt) => {
                editField.onChange(evt, editField.field, editField.is_multiple);
              }}
            />
          </>
        );
      }
    } catch (error) {
      console.log(error);
    }
  } else if (editField.attribute_type === "date") {
    const currentDate = new Date();
    const pastDate = currentDate.setDate(currentDate.getDate() - 30);
    return (
      <ReactDatePicker
        selected={
          state.formdata[editField.field] &&
          !isNaN(Date.parse(state.formdata[editField.field]))
            ? new Date(state.formdata[editField.field])
            : null
        }
        name={editField.field}
        dateFormat="dd-MM-yyyy"
        minDate={pastDate}
        disabled={editField.disabled}
        onChange={(evt) => dateChangeHandler(evt, editField.field)}
        onBlur={!editField.show_reason ? editField.onBlur : getCalenderBlur}
        ref={dateRef}
        className="rasta-stripes"
        autoComplete="off"
        placeholderText={editField.placeholder || "dd-mm-yyyy"}
      />
      // <input
      //   type="date"
      //   value={editField.rows[editField.field]}
      //   name={editField.field}
      //   onChange={editField.onChange}
      //   ref={editField.refs}
      //   className="form-control"
      //   onBlur={editField.onBlur}
      // />
    );
  } else if (editField.attribute_type === "timestamp") {
    const currentDate = new Date();
    const pastDate = currentDate.setDate(currentDate.getDate() - 30);
    return (
      <ReactDatePicker
        selected={
          state.formdata[editField.field] &&
          !isNaN(Date.parse(state.formdata[editField.field]))
            ? new Date(state.formdata[editField.field])
            : null
        }
        name={editField.field}
        dateFormat="dd-MM-yyyy"
        minDate={pastDate}
        onChange={(evt) => dateChangeHandler(evt, editField.field)}
        onBlur={!editField.show_reason ? editField.onBlur : getCalenderBlur}
        ref={dateRef}
        className="rasta-stripes"
        autoComplete="off"
        placeholderText="dd-mm-yyyy"
      />
      // <input
      //   type="date"
      //   value={editField.rows[editField.field]}
      //   name={editField.field}
      //   onChange={editField.onChange}
      //   ref={editField.refs}
      //   className="form-control"
      //   onBlur={editField.onBlur}
      // />
    );
  } else if (editField.attribute_type === "assign_to") {
    const options = [];

    const ImageOption = (props) => {
      const { Option } = components;
      const getimage = props.options.find(
        (item) => item.value === props.value,
      ).profile;
      return (
        <Option {...props}>
          <img
            style={{ width: "15px", borderRadius: "50%", height: "15px" }}
            src={`${
              getimage ||
              "data:image/png;base64,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"
            }`}
          />{" "}
          {props.data.label}
        </Option>
      );
    };

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions
        maxMenuHeight={175}
        value={state.users?.filter(
          (fil) => fil.value == editField.rows[editField.field],
        )}
        loadOptions={(evt) => getPeoplesCall(evt, editField.api_url)}
        menuPlacement="auto"
        {...(editField.menuIsOpen !== undefined
          ? { menuIsOpen: editField.menuIsOpen }
          : {})}
        ref={editField.refs}
        styles={customStyles}
        components={{ Option: CustomOption }}
        onBlur={editField.onBlur}
        onChange={(evt) => editField.onChange(evt, editField.field)}
      />
    );
  } else if (editField.attribute_type === "customer") {
    try {
      const options = editField.options;
      let newoptions = [];
      if (options !== undefined) {
        for (let i in options) {
          newoptions.push({
            label: `${options[i]?.name} (${options[i]?.email})`,
            value: options[i]?.email,
          });
        }
      }
      return (
        <ReactSelect
          name={editField.field}
          options={newoptions}
          value={newoptions.filter(
            (fil) => fil.value === editField.rows[editField.field],
          )}
          ref={editField.refs}
          menuPlacement="auto"
          maxMenuHeight={175}
          className="abc"
          onBlur={() =>
            editField.onBlur(editField.rows[editField.field], editField.field)
          }
          onChange={(evt) => editField.onChange(evt, editField.field)}
          styles={customStyles}
        />
      );
    } catch (error) {
      console.log(error);
    }
  } else if (editField.attribute_type === "account_manager") {
    try {
      const options = editField.options;
      let newoptions = [];
      if (options !== undefined) {
        for (let i in options) {
          newoptions.push({
            label: `${options[i]?.name}`,
            value: options[i]?.user_uuid,
          });
        }
      }
      return (
        <ReactSelect
          name={editField.field}
          options={newoptions}
          styles={customStyles}
          value={newoptions.filter(
            (fil) => fil.value === editField.rows[editField.field],
          )}
          ref={editField.refs}
          menuPlacement="auto"
          maxMenuHeight={175}
          className="abc"
          onBlur={() =>
            editField.onBlur(editField.rows[editField.field], editField.field)
          }
          onChange={(evt) => editField.onChange(evt, editField.field)}
        />
      );
    } catch (error) {
      console.log(error);
    }
  } else if (editField.attribute_type === "er") {
    try {
      return (
        <AsyncSelect
          cacheOptions
          defaultOptions
          maxMenuHeight={175}
          styles={customStyles}
          loadOptions={(evt) => editField?.getApiCall(editField.api_url, evt)}
          name={editField.field}
          value={testFilter[0].filter((fil) =>
            editField.rows[editField.field]?.includes(fil?.value?.toString()),
          )}
          ref={editField.refs}
          className="abc"
          isMulti={true}
          onBlur={() =>
            editField.onBlur(editField.rows[editField.field], editField.field)
          }
          onChange={(evt) => editField.onChange(evt, editField.field, true)}
        />
      );
    } catch (error) {
      console.log(error);
    }
  } else if (
    editField.attribute_type === "reporter" ||
    editField.attribute_type === "people"
  ) {
    const options = [];

    const ImageOption = (props) => {
      const { Option } = components;
      const getimage = props.options.find(
        (item) => item.value === props.value,
      ).pro_image;
      return (
        <Option {...props}>
          <img
            style={{ width: "20px", borderRadius: "50px", height: "20px" }}
            src={`${getimage}`}
          />{" "}
          &nbsp;
          {props.data.label}
        </Option>
      );
    };

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions
        maxMenuHeight={175}
        isDisabled={editField.disabled}
        placeholder={editField.placeholder || "Select user..."}
        value={state.users?.filter(
          (fil) => fil.value == editField.rows?.[editField.field],
        )}
        loadOptions={(evt) => getPeoplesCall(evt, editField.api_url)}
        menuPlacement="auto"
        {...(editField.menuIsOpen !== undefined
          ? { menuIsOpen: editField.menuIsOpen }
          : {})}
        ref={editField.refs}
        styles={customStyles}
        components={{ Option: CustomOption }}
        onBlur={editField.onBlur}
        onChange={(evt) => editField.onChange(evt, editField.field)}
      />
    );
  } else if (editField.attribute_type == "effort") {
    return (
      <>
        <div className="inputbox-group effort_class_control" ref={inputEffort}>
          <div className="groupday">
            <input
              type="text"
              className="form-control days"
              name="effort_in_days"
              value={
                effortInput[editField.field]?.effort_in_days
                  ? effortInput[editField.field]?.effort_in_days
                  : 0
              }
              // style={{ width: 60 }}
              onChange={(evt) => effortChangeHandler(evt)}
              autoComplete="off"
            />
          </div>

          <div className="grouphour">
            <input
              type="text"
              name="effort_in_hours"
              min="0"
              className="form-control hours"
              value={
                effortInput[editField.field]?.effort_in_hours
                  ? effortInput[editField.field]?.effort_in_hours
                  : 0
              }
              // style={{ width: 60 }}
              onChange={(evt) => effortChangeHandler(evt)}
              autoComplete="off"
            />
          </div>
        </div>
        <span className="error-feedback">
          {isValidationcheck["errors"]?.["effort_in_days"]?.message
            ? `${
                isValidationcheck["errors"]?.["effort_in_days"]?.message &&
                isValidationcheck["errors"]?.["effort_in_days"]?.message
              }`
            : ""}{" "}
          {isValidationcheck["errors"]?.["effort_in_hours"]?.message
            ? `${
                isValidationcheck["errors"]?.["effort_in_hours"]?.message &&
                isValidationcheck["errors"]?.["effort_in_hours"]?.message
              }`
            : ""}{" "}
        </span>
      </>
    );
  } else if (editField.attribute_type === "monitoring") {
    const options = [];
    if (Array.isArray(editField.options)) {
    } else {
      for (let ioo in editField.options) {
        options.push({
          label: editField.options[ioo].name,
          value: editField.options[ioo].user_uuid,
        });
      }
    }

    const ImageOption = (props) => {
      const { Option } = components;
      const getimage = props.options.find(
        (item) => item.value === props.value,
      ).profile;
      return (
        <Option {...props}>
          <img style={{ width: "20px", height: "20px" }} src={`${getimage}`} />{" "}
          &nbsp;
          {props.data.label}
        </Option>
      );
    };
    return (
      <div className="monitorBox">
        {getAddMonitordata()?.length > 0 &&
          [...new Set(getAddMonitordata())].map((item) => (
            <PopOver
              users={props.users}
              item={item}
              removeMonitorHandler={removeMonitorHandler}
              app_token={boardData.app_token}
            />
          ))}
        <OverlayTrigger
          key={"monitor"}
          placement={"right"}
          overlay={
            <Tooltip id={`tooltip-monitor`}>
              <strong>
                {editField?.headerName
                  ? `Add ${editField.headerName}`
                  : "Add Monitor"}
              </strong>
            </Tooltip>
          }
        >
          <div
            className="addMonitorBox"
            data-bs-toggle="modal"
            data-bs-target="#addNewMonitor"
            onClick={() => props.AddMonitorHandler(editField)}
          >
            +
          </div>
        </OverlayTrigger>
      </div>
    );
  } else {
    return (
      <>
        <input
          type="text"
          value={editField.rows?.[editField.field]}
          name={editField.field}
          placeholder={editField.placeholder}
          disabled={editField.disabled}
          onChange={editField.onChange}
          ref={editField.refs}
          className="form-control"
          onBlur={editField.onBlur}
        />
      </>
    );
  }
});
export default memo(EditField);
